
import $ from "jquery";

$(function(){
    // burger navigation
    if ( $('#burger').length ){
        $('#burger').on('click', function(){
            $('nav#mainnav').toggleClass('open');
            $('nav#mainnav > ul').slideToggle(300);
            $('li.firstLevel:first-child > svg').click();
        });
        $('li.firstLevel > svg').on('click', function(){
            if ( !$(this).parent().hasClass('open') && $('li.firstLevel.open').length ){
                $('li.firstLevel.open ul').slideUp(300);
                $('li.firstLevel.open').removeClass('open');
            }
            $(this).next('ul').slideToggle(300);
            $(this).parent().toggleClass('open');
        });
        $('li.hasSub > svg').on('click', function(){
            if ( !$(this).parent().hasClass('open') && $('li.hasSub.open').length ){
                $('li.hasSub.open ul').slideUp(300);
                $('li.hasSub.open').removeClass('open');
            }
            $(this).next('ul').slideToggle(300);
            $(this).parent().toggleClass('open');
        });
    }

});// document ready